// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","container":"input_container__jRJbw","title":"input_title__31FLg","input":"input_input__vQ0u+","filled":"input_filled__4Xboy","error":"input_error__4G0uY"};